export const ROUTER = {
  AUTH: '/',
  SIGN_UP: '/sign-up',
  CREATE_BOT_SIGN_UP: '/sign-up/create-bot',
  CREATE_WEBSITE_SIGN_UP: '/sign-up/create-website',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFICATION: '/verification',
  BUSINESS_DETAILS: '/business-details',
  PRIVACY_POLICY: 'privacy-policy',
  PUBLIC_OFFER: 'public-offer',
  CREATE_BOT: '/create-bot',
  CREATE_WEBSITE: '/create-website',
  CREATE_SETTINGS: 'settings',
  CREATE_CATEGORY: 'category',
  CREATE_PRODUCT: 'product',
  CREATE_DELIVERY: 'delivery',
  CREATE_PREVIEW: 'preview',
  EMPLOYEES: 'employees',
  EMPLOYEES_ROLES: 'roles',
  EMPLOYEES_COURIER: 'courier',
  ADMIN: '/admin',
  ADMIN_HOME: '/admin/dashboard',
  DASHBOARD: 'dashboard',
  ORDERS: 'orders',
  ORDERS_NEW: 'new',
  ORDERS_PROGRESS: 'progress',
  ORDERS_LATE: 'late',
  ORDERS_READY: 'ready',
  ORDERS_ON_THE_WAY: 'on-the-way',
  ORDERS_AUTO_RESPONDER: 'auto-responder',
  ORDERS_HISTORY: 'history',
  CUSTOMERS: 'customers',
  CUSTOMER_ID: ':customerId',
  ROBO_MARKET_APP_ID: ':roboMarketAppId',
  INSTAGRAM: 'instagram',
  CHAT: 'chat',
  CHAT_ID: ':chatId',
  MARKETING: 'marketing',
  PRODUCTS: 'products',
  BRANCHES: 'branches',
  SETTINGS: 'settings',
  PRICING_PLAN: 'pricing-plan',
  BANNERS: 'banners',
  PAYMENT: 'payment',
  PAYMENT_HISTORY: 'payment-history',
  PLATFORMS: 'platforms',
  WEBSITE: 'website',
  QR_CODE: 'qr-code',
  WEBSITE_DOMAIN: 'domain',
  WEBSITE_ANALYTICS: 'analytics',
  TELEGRAM_BOTS: 'telegram-bots',
  TELEGRAM_BOTS_ACTIONS: 'actions',
  PLATFORM_CREATE: 'create',
  CREATE: 'create',
  EDIT: 'edit',
  DELIVERY: 'delivery',
  CATEGORIES: 'categories',
  CATEGORY_ID: ':categoryId',
  PRODUCT_ID: ':productId',
  BANNER_ID: ':bannerId',
  PLAN_ID: ':planId',
  DISCOUNT_ID: ':discountId',
  IKPU: 'ikpu',
  STOCK: 'stock',
  DISCOUNT: 'discount',
  ROBO_MARKET: 'market',
  MARKETING_NEWS: 'news',
  MARKETING_REVIEWS: 'reviews',
  MARKETING_MAILING: 'mailing',
  MARKETING_SMS_MAILING: 'sms-mailing',
  MAILING_ID: ':mailingId',
  SMS_MAILING_ID: ':smsMailingId',
  MARKETING_CREATE_MAILING: 'create-mailing',
  MARKETING_PROMO_CODE: 'promo-code',
  MARKETING_POST: 'post',
  MARKETING_SOURCES: 'marketing-sources',
  PROFILE: 'profile',
  PROFILE_PASSWORD: 'password',
  PROFILE_CARDS: 'cards',
  PROFILE_LANGUAGE: 'language',
  PROFILE_PLATFORMAS: 'platformas',
  PROFILE_NOTIFICATIONS: 'notifications',
  PROFILE_API_INTEGRATION: 'api-integration',
  NOT_FOUND: '*',
}
